var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_10x10_flag_photo",
    "data-name": "10x10 flag photo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4644",
    "data-name": "Rectangle 4644",
    width: 10,
    height: 10,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_274",
    "data-name": "Mask Group 274",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attach"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9988",
    "data-name": "Group 9988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21273",
    "data-name": "Path 21273",
    d: "M9.064,1.2a3.2,3.2,0,0,0-4.521,0L.668,5.078A2.283,2.283,0,0,0,3.9,8.307L7.449,4.755A1.37,1.37,0,1,0,5.512,2.817L3.189,5.14a.457.457,0,1,0,.646.646L6.157,3.463a.457.457,0,1,1,.646.646L3.251,7.661A1.37,1.37,0,0,1,1.313,5.723L5.189,1.848A2.283,2.283,0,1,1,8.418,5.078L4.543,8.953a.457.457,0,0,0,.646.646L9.064,5.723a3.2,3.2,0,0,0,0-4.521Z",
    fill: "#8e8e8e"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.170adaac5325065990cdb3fa2cbf5f12.svg";
export { ForwardRef as ReactComponent };